// extracted by mini-css-extract-plugin
module.exports = {"left_side_wrapper":"LeftSide_left_side_wrapper__aLi3Z","logo":"LeftSide_logo__0rJBF"};